export const getNavMicrosites = (menus) => {
    if (!menus) {
        return null;
    }
    const navReferences = [];
    menus.forEach(menuItem => {
        if (menuItem.children) {
            menuItem.children.forEach(menuItemChild => {
                if (menuItemChild.type === "brand" && menuItemChild.ref) {
                    navReferences.push(menuItemChild.ref);
                }
            });
        }
        if (menuItem.type === "brand" && menuItem.ref) {
            navReferences.push(menuItem.ref);
        }
    });
    return navReferences;
};
export const getCoastHints = (tags) => {
    return (tags
        ?.filter(tag => tag.startsWith("display-hints/coast") || tag.includes("tile"))
        .map(tag => tag.replace("display-hints/", "")) || []);
};
export const isPrimaryBlock = (tags = []) => {
    return tags ? tags.includes("display-hints/primary") : false;
};
//# sourceMappingURL=Sites.utils.js.map